<template>
  <div ref="dropdownEl" class="hs-dropdown relative [--trigger:click]">
    <slot :attr="{ class: 'hs-dropdown-toggle cursor-pointer' }" name="toggler">
      <button
        type="button"
        class="hs-dropdown-toggle flex items-center gap-x-[7px] p-[6px_10px] sm:p-[10px_14px] rounded-[4px] border border-blue default-transition hs-dropdown-open:bg-[#E1E9F8]"
      >
        <InlineSvg
          src="/assets/svg/icons/chevron-down.svg"
          class="default-transition"
        />
        <span
          class="text-blue text-[10px] sm:text-[14px] font-medium leading-[16px]"
          >{{ title }}</span
        >
      </button>
    </slot>

    <div
      class="hs-dropdown-menu transition-[opacity,margin] duration hs-dropdown-open:opacity-100 opacity-0 hidden z-20 !mt-[-10px] pt-[16px]"
    >
      <div
        class="hs-dropdown-menu-contaienr z-20 bg-white border border-[#E1E9F8] relative"
        :class="contentClasses"
      >
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  contentClasses: {
    type: String,
    default: '',
  },
  trigger: {
    type: String,
    default: 'click',
  },
  menuWidth: {
    type: [Number, String],
    default: 0,
  },
});
const dropdownEl = ref(null);

onMounted(() => {
  dropdownEl.value.addEventListener('open.hs.dropdown', () => {
    const width =
      (props.menuWidth ? props.menuWidth : dropdownEl.value.clientWidth) + 'px';
    const menuEl = dropdownEl.value.querySelector('.hs-dropdown-menu');
    menuEl.style.width = width;
  });
});
</script>
